import { useEffect, useState } from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { apiUrl } from '../../utilities/apiUrl';

export const PhClock = () => {
  const [time, setTime] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let serverTime = null;
    let interval = null;

    async function fetchServerTime() {
      try {
        const response = await fetch(apiUrl(`/timesheet/servertime`), {
          method: 'GET',
          credentials: 'include',
        });
        const data = await response.json();

        serverTime = new Date(data.serverTime);

        // Set initial time and stop loading
        const options = {
          timeZone: 'Asia/Manila',
          hour12: true,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        };
        setTime(serverTime.toLocaleTimeString('en-PH', options));
        setLoading(false);

        // Start ticking every second
        interval = setInterval(() => {
          serverTime.setSeconds(serverTime.getSeconds() + 1);
          setTime(serverTime.toLocaleTimeString('en-PH', options));
        }, 1000);
      } catch (err) {
        console.error('Failed to fetch server time', err);
      }
    }

    fetchServerTime();

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: '#84d8c5',
        padding: '12px 20px',
        borderRadius: '5px',
        width: '90%',
      }}
    >
      {loading ? (
        <Skeleton variant="text" width={400} height={48} />
      ) : (
        <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
          {time}
        </Typography>
      )}
    </Box>
  );
};
